import React from 'react'
import { Checkbox, CheckboxProps } from 'semantic-ui-react'

import { PermissionGroup } from './PermissionGroup'
import { OnCheck } from './AllPermissions'

interface ReportPermissionsProps {
  onChange: (data: OnCheck) => void
  isChecked: (resource: string, actions: string[]) => boolean
}

export const ReportPermissions: React.FC<ReportPermissionsProps> = ({
  onChange,
  isChecked
}) => {
  function handleCheck(
    event: React.FormEvent<HTMLInputElement>,
    data: CheckboxProps
  ) {
    const value = data.value as string
    const checked = data.checked as boolean
    onChange({ value, checked })
  }

  return (
    <PermissionGroup label="Relatórios:">
      <Checkbox
        onChange={handleCheck}
        checked={isChecked('report', ['CommissionReport'])}
        value="report:CommissionReport"
        label="Relatório de comissão"
      />
      <Checkbox
        onChange={handleCheck}
        checked={isChecked('report', ['CostReport'])}
        value="report:CostReport"
        label="Relatório de custo"
      />
    </PermissionGroup>
  )
}
